import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-component',
  templateUrl: './blank-component.component.html',
  styleUrls: ['./blank-component.component.scss']
})
export class BlankComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
